// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__vDPa-","form-container":"Signup_form-container__vIBsC","popup-content":"Signup_popup-content__-d6PX"};